import React, {FC} from 'react';

import {Renderer, RendererOf} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {FilterButton} from '../common/filterButton';

/*
 * Props.
 */

export interface FilterDropdownBoxProps {
  renderDropdown: RendererOf<PopoverTransferProps>;
  renderButton: Renderer;
  isActive?: boolean;
  isDisabled?: boolean;
  onPopoverToggle?: (arg: boolean) => void;
  noBorderRadius?: boolean;
  color?: string;
}

/*
 * Component.
 */

export const FilterDropdownBox: FC<FilterDropdownBoxProps> = ({
  isActive,
  isDisabled,
  renderDropdown,
  renderButton,
  onPopoverToggle,
  noBorderRadius,
  color,
}) => {
  const renderFilterButton = (isOpen: boolean) => (
    <FilterButton
      hasChevron
      isActive={isActive ?? false}
      isDisabled={isDisabled ?? false}
      hasForcedHover={isOpen}
      noBorderRadius={noBorderRadius}
      color={color}
    >
      {renderButton()}
    </FilterButton>
  );

  return (
    <DropdownBoxCoordinator
      isDisabled={isDisabled}
      renderDropdown={renderDropdown}
      renderButton={renderFilterButton}
      shouldDisablePadding
      onPopoverToggle={onPopoverToggle}
    />
  );
};
